/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import {
  SETTINGS_FETCH_REQUEST,
  SETTINGS_FETCH_REQUEST_SUCCESS,
  SETTINGS_FETCH_REQUEST_FAILURE,
  SETTINGS_UPDATE_REQUEST,
  SETTINGS_UPDATE_REQUEST_SUCCESS,
  SETTINGS_UPDATE_REQUEST_FAILURE,
  SETTINGS_UPDATE_TAX_REQUEST,
  SETTINGS_UPDATE_TAX_REQUEST_SUCCESS,
  SETTINGS_UPDATE_TAX_REQUEST_FAILURE,
  SETTINGS_FETCH_TAX_REQUEST,
  SETTINGS_FETCH_TAX_REQUEST_SUCCESS,
  SETTINGS_FETCH_TAX_REQUEST_FAILURE,
  SETTINGS_CSV_UPLOAD_REQUEST,
  SETTINGS_CSV_UPLOAD_REQUEST_SUCCESS,
  SETTINGS_CSV_UPLOAD_REQUEST_FAILURE,
  SETTINGS_CSV_UPLOAD_CLEAN_REQUEST,
  SETTINGS_CSV_UPLOAD_CONFIRM_CLEAN_REQUEST,
  SETTINGS_CSV_UPLOAD_CONFIRM_REQUEST,
  SETTINGS_CSV_UPLOAD_CONFIRM_REQUEST_SUCCESS,
  SETTINGS_CSV_UPLOAD_CONFIRM_REQUEST_FAILURE,
  SETTINGS_CSV_HISTORY_FETCH_REQUEST,
  SETTINGS_CSV_HISTORY_FETCH_REQUEST_SUCCESS,
  SETTINGS_CSV_HISTORY_FETCH_REQUEST_FAILURE,
  SETTINGS_FETCH_COLOR_REQUEST,
  SETTINGS_FETCH_COLOR_REQUEST_SUCCESS,
  SETTINGS_FETCH_COLOR_REQUEST_FAILURE,
  APPOINTMENT_POLICY_FETCH_REQUEST,
  APPOINTMENT_POLICY_FETCH_REQUEST_SUCCESS,
  APPOINTMENT_POLICY_FETCH_REQUEST_FAILURE,
  APPOINTMENT_POLICY_UPSERT_REQUEST,
  APPOINTMENT_POLICY_UPSERT_REQUEST_SUCCESS,
  APPOINTMENT_POLICY_UPSERT_REQUEST_FAILURE,
  SETTINGS_FETCH_CUSTOM_STATUS_REQUEST,
  SETTINGS_FETCH_CUSTOM_STATUS_REQUEST_SUCCESS,
  SETTINGS_FETCH_CUSTOM_STATUS_REQUEST_FAILURE,
  SETTINGS_UPSERT_CUSTOM_STATUS_REQUEST,
  SETTINGS_UPSERT_CUSTOM_STATUS_REQUEST_SUCCESS,
  SETTINGS_UPSERT_CUSTOM_STATUS_REQUEST_FAILURE,
  SETTINGS_CLEAN_REQUEST,
  SETTINGS_BILLING_REQUEST,
  SETTINGS_BILLING_REQUEST_SUCCESS,
  SETTINGS_BILLING_REQUEST_FAILURE,
  COLUMN_HEADER_MAP_REQUEST,
  COLUMN_HEADER_MAP_REQUEST_SUCCESS,
  COLUMN_HEADER_MAP_REQUEST_FAILURE,
  CLEAN_CSV_HEADER_MAP_REQUEST,
  CONFIGURE_DOCUMENTS_NUMBER,
  CONFIGURE_DOCUMENTS_NUMBER_SUCCESS,
  CONFIGURE_DOCUMENTS_NUMBER_FAILURE,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  taxPayload: [],
  taxLoading: false,
  taxErrors: {},
  csvPayload: [],
  csvLoading: false,
  csvErrors: {},
  csvHistoryPayload: [],
  csvHistoryPagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  csvHistoryLoading: false,
  csvHistoryErrors: {},
  singleCsvPayload: [],
  singleCsvLoading: false,
  singleCsvErrors: {},
  colorPayload: [],
  colorLoading: false,
  colorErrors: {},
  policyPayload: [],
  policyLoading: false,
  policyErrors: {},
  policyUpdatePayload: [],
  policyUpdateLoading: false,
  policyUpdateErrors: {},
  customStatusPayload: [],
  customStatusLoading: false,
  customStatusErrors: {},
  customStatusUpdatePayload: [],
  customStatusUpdateLoading: false,
  customStatusUpdateErrors: {},
  billingPayload: [],
  billingLoading: false,
  billingErrors: {},
  columnHeaderMap: [],
  columnHeaderMapLoading: false,
  columnHeaderMapErrors: {},
  configureDocumentsNumber: [],
  configureDocumentsNumberLoading: false,
  configureDocumentsNumberErrors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const settingReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case SETTINGS_FETCH_REQUEST:
    case SETTINGS_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SETTINGS_FETCH_REQUEST_SUCCESS:
    case SETTINGS_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case SETTINGS_FETCH_REQUEST_FAILURE:
    case SETTINGS_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SETTINGS_FETCH_TAX_REQUEST:
    case SETTINGS_UPDATE_TAX_REQUEST:
      return Object.assign({}, state, {
        taxLoading: true,
      });

    case SETTINGS_FETCH_TAX_REQUEST_SUCCESS:
    case SETTINGS_UPDATE_TAX_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taxLoading: false,
        taxPayload: action.data,
        taxErrors: {},
      });

    case SETTINGS_FETCH_TAX_REQUEST_FAILURE:
    case SETTINGS_UPDATE_TAX_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taxLoading: false,
        taxErrors: action.error,
      });

    case SETTINGS_CSV_UPLOAD_REQUEST:
      return Object.assign({}, state, {
        csvLoading: true,
      });

    case SETTINGS_CSV_UPLOAD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        csvLoading: false,
        csvPayload: action.data,
        csvErrors: {},
      });

    case SETTINGS_CSV_UPLOAD_REQUEST_FAILURE:
      return Object.assign({}, state, {
        csvLoading: false,
        csvErrors: action.error,
      });

    case SETTINGS_CSV_UPLOAD_CLEAN_REQUEST:
      return Object.assign({}, state, {
        csvPayload: [],
        csvLoading: false,
        csvErrors: {},
      });

    case SETTINGS_CSV_UPLOAD_CONFIRM_REQUEST:
      return Object.assign({}, state, {
        singleCsvLoading: true,
      });

    case SETTINGS_CSV_UPLOAD_CONFIRM_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleCsvLoading: false,
        singleCsvPayload: action.data,
        singleCsvErrors: {},
      });

    case SETTINGS_CSV_UPLOAD_CONFIRM_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleCsvLoading: false,
        singleCsvErrors: action.error,
      });

    case SETTINGS_CSV_UPLOAD_CONFIRM_CLEAN_REQUEST:
      return Object.assign({}, state, {
        singleCsvPayload: [],
        singleCsvLoading: false,
        singleCsvErrors: {},
      });

    case SETTINGS_CSV_HISTORY_FETCH_REQUEST:
      return Object.assign({}, state, {
        csvHistoryLoading: true,
      });

    case SETTINGS_CSV_HISTORY_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        csvHistoryLoading: false,
        csvHistoryPayload: action.data,
        csvHistoryErrors: {},
        csvHistoryPagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
          showSizeChanger: true,
        },
      });

    case SETTINGS_CSV_HISTORY_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        csvHistoryLoading: false,
        csvHistoryErrors: action.error,
      });

    case SETTINGS_FETCH_COLOR_REQUEST:
      return Object.assign({}, state, {
        colorLoading: true,
      });

    case SETTINGS_FETCH_COLOR_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        colorLoading: false,
        colorPayload: action.data,
        colorErrors: {},
      });

    case SETTINGS_FETCH_COLOR_REQUEST_FAILURE:
      return Object.assign({}, state, {
        colorLoading: false,
        colorErrors: action.error,
      });

    case APPOINTMENT_POLICY_UPSERT_REQUEST:
      return Object.assign({}, state, {
        policyUpdateLoading: true,
      });

    case APPOINTMENT_POLICY_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        policyUpdateLoading: false,
        policyUpdatePayload: action.data,
        policyUpdateErrors: {},
      });

    case APPOINTMENT_POLICY_UPSERT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        policyUpdateLoading: false,
        policyUpdateErrors: action.error,
      });

    case APPOINTMENT_POLICY_FETCH_REQUEST:
      return Object.assign({}, state, {
        policyLoading: true,
      });

    case APPOINTMENT_POLICY_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        policyLoading: false,
        policyPayload: action.data,
        policyErrors: {},
      });

    case APPOINTMENT_POLICY_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        policyLoading: false,
        policyErrors: action.error,
      });

    case SETTINGS_FETCH_CUSTOM_STATUS_REQUEST:
      return Object.assign({}, state, {
        customStatusLoading: true,
      });

    case SETTINGS_FETCH_CUSTOM_STATUS_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        customStatusLoading: false,
        customStatusPayload: action.data,
        customStatusErrors: {},
      });

    case SETTINGS_FETCH_CUSTOM_STATUS_REQUEST_FAILURE:
      return Object.assign({}, state, {
        customStatusLoading: false,
        customStatusErrors: action.error,
      });

    case SETTINGS_UPSERT_CUSTOM_STATUS_REQUEST:
      return Object.assign({}, state, {
        customStatusUpdateLoading: true,
      });

    case SETTINGS_UPSERT_CUSTOM_STATUS_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        customStatusUpdateLoading: false,
        customStatusUpdatePayload: action.data,
        customStatusUpdateErrors: {},
      });

    case SETTINGS_UPSERT_CUSTOM_STATUS_REQUEST_FAILURE:
      return Object.assign({}, state, {
        customStatusUpdateLoading: false,
        customStatusUpdateErrors: action.error,
      });

    case SETTINGS_BILLING_REQUEST:
      return Object.assign({}, state, {
        billingLoading: true,
      });

    case SETTINGS_BILLING_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        billingLoading: false,
        billingPayload: action.data,
        billingErrors: {},
      });

    case SETTINGS_BILLING_REQUEST_FAILURE:
      return Object.assign({}, state, {
        billingLoading: false,
        billingErrors: action.error,
      });

    case SETTINGS_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        taxPayload: [],
        taxLoading: false,
        taxErrors: {},
        csvPayload: [],
        csvLoading: false,
        csvErrors: {},
        csvHistoryPayload: [],
        csvHistoryPagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
        csvHistoryLoading: false,
        csvHistoryErrors: {},
        singleCsvPayload: [],
        singleCsvLoading: false,
        singleCsvErrors: {},
        colorPayload: [],
        colorLoading: false,
        colorErrors: {},
        policyPayload: [],
        policyLoading: false,
        policyErrors: {},
        policyUpdatePayload: [],
        policyUpdateLoading: false,
        policyUpdateErrors: {},
        customStatusPayload: [],
        customStatusLoading: false,
        customStatusErrors: {},
        customStatusUpdatePayload: [],
        customStatusUpdateLoading: false,
        customStatusUpdateErrors: {},
        billingPayload: [],
        billingLoading: false,
        billingErrors: {},
      });

    case COLUMN_HEADER_MAP_REQUEST:
      return Object.assign({}, state, {
        columnHeaderMapLoading: true,
      });

    case COLUMN_HEADER_MAP_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        columnHeaderMapLoading: false,
        columnHeaderMap: action.data,
        columnHeaderMapErrors: {},
      });

    case COLUMN_HEADER_MAP_REQUEST_FAILURE:
      return Object.assign({}, state, {
        columnHeaderMapLoading: false,
        columnHeaderMapErrors: action.error,
      });

    case CLEAN_CSV_HEADER_MAP_REQUEST:
      return Object.assign({}, state, {
        columnHeaderMapLoading: false,
        columnHeaderMap: [],
        columnHeaderMapErrors: {},
      });

    case CONFIGURE_DOCUMENTS_NUMBER:
      return Object.assign({}, state, {
        configureDocumentsNumberLoading: true,
      });

    case CONFIGURE_DOCUMENTS_NUMBER_SUCCESS:
      return Object.assign({}, state, {
        configureDocumentsNumberLoading: false,
        configureDocumentsNumber: action.data,
        configureDocumentsNumberErrors: {},
      });

    case CONFIGURE_DOCUMENTS_NUMBER_FAILURE:
      return Object.assign({}, state, {
        configureDocumentsNumberLoading: false,
        configureDocumentsNumberErrors: action.error,
      });

    default:
      return state;
  }
};

export default settingReducer;
